
import { InputField } from "../../components/form/input.field.component";
import { API_END_POINT } from "../../constants";
import { FormikModelDialog, SubmitStatus } from "../../core/formik-model-dialog.component";
import TalukModel from "../../models/masters/taluk-model";
import * as Yup from "yup";
import { useEffect, useState } from "react";
import { SelectField } from "../../core/select-field.component";
import { useGetWards } from "../../apiclient/master/useGetWardApi";
import { useGetDistrict } from "../../apiclient/master/useGetDistrictApi";
import { useGetTaluks } from "../../apiclient/master/useGetTalukApi";

interface TalukEditProps {
  data: TalukModel;
  isViewMode?: boolean; // 
  onClose?: (status: SubmitStatus, data: any) => any;
}


const TalukEntry: React.FC<TalukEditProps> = ({ ...props }) => {
  let { data, onClose,isViewMode } = props;
  const title = data?.talukId > 0 ? "Edit Taluk" : "Add Taluk";

  let initialValue: TalukModel = {
    talukId: data?.talukId ? data.talukId : 0,
    name: data?.name,
   

  };
  const validationSchema = Yup.object().shape({
    name: Yup.string()
    .required("Required")
    .test("check-duplicate-name", "Taluk name already exists", (value) => {
      // Ensure the value is compared in a case-insensitive manner
      return (
        value &&
        !existingName.some(existing => existing.toLowerCase() === value.toLowerCase()) ||
        (data?.name && value === data.name) // Allow current name during update
      );
    }), 
  });
  console.log(initialValue)

    
  const [existingName, setExistingName] = useState<string[]>([]); // state to hold existing zone names
  const { data: fetchedTaluk } = useGetTaluks();
  
  
  useEffect(() => {
    if (fetchedTaluk) {
        setExistingName(fetchedTaluk.map((zone: any) => zone.name)); // Extracting zone names to compare against
    }
}, [fetchedTaluk]);



  const [districtData, setDistrictData] = useState<{ value: string; label: string }[]>([]);
  const { data: fetchedDistrict } = useGetDistrict();
  useEffect(() => {
    if (fetchedDistrict) {
      const mappedDistrict = fetchedDistrict.map((district: any) => ({
        value: district.districtId.toString(),
        label: district.name,
      }));
      setDistrictData(mappedDistrict);
    }
  }, [fetchedDistrict]);

  return (
    <>
      <FormikModelDialog
        width="50%"
        title={title}
        initialData={initialValue}
        validationSchema={validationSchema}
        show={!!data}
        onClose={onClose}
        endpoint={API_END_POINT.MASTER}
        postRoute="Taluk/SaveTaluk"
        showAddAnother={true}
        isViewOnly ={isViewMode}
        isUpDateEntityDetails={data?.talukId > 0 ? true : false}

      >
        <div>
          <div className="row">
            <div className="col-8">
              <InputField maxLength={100} label="Taluk *" name="name" />
            </div>
            <div className="col-6">

              {/* <SelectField
                label="District Name"
                name="districtId"
                options={districtData}
                unSelectValue={0}
              /> */}
            </div>
          </div>
        </div>
      </FormikModelDialog>
    </>
  );
};


export default TalukEntry;

